document.addEventListener("DOMContentLoaded", function() {
  // Swatch Modal Elements
  var swatchModal = document.getElementById("swatch-modal");
  var swatchModalImg = document.getElementById("modal-image");
  var swatchModalColourTitle = document.getElementById("modal-colour-title");
  var swatches = document.getElementsByClassName("swatch-img");

  // Affiliate Modal Elements
  var affiliateModal = document.getElementById("affiliate-modal");
  var affiliateModalImg = document.getElementById("modal-affiliate-image");
  var affiliateItems = document.getElementsByClassName("affiliate-img");

  // Wholesale Modal Elements
  var wholesaleModal = document.getElementById("wholesale-modal");
  var wholesaleLink = document.getElementById("wholesale-link");

  // Shared Elements
  var closeBtns = document.getElementsByClassName("close");
  var prevBtns = document.getElementsByClassName("prev");
  var nextBtns = document.getElementsByClassName("next");
  var currentIndex = 0;

  // Function to format swatch colour title
  function formatSwatchColourTitle(colour) {
  var parts = colour.split('-');
  return parts.slice(1).join(' | ');
  }

  // Function to open the Swatch Modal
  function openSwatchModal(index) {
    // swatchModal.style.display = "flex";
  // swatchModalImg.src = swatches[index].src;
  // swatchModalColourTitle.textContent = formatSwatchColourTitle(swatches[index].getAttribute("data-colour"));
  // currentIndex = index;
  // updateNavButtons();
  }

  // Function to open the Affiliate Modal
  function openAffiliateModal(index) {
    // affiliateModal.style.display = "flex";
    // affiliateModalImg.src = affiliateItems[index].getAttribute("data-modal-src");
    // currentIndex = index;
    // updateNavButtons();
  }

  // Function to open the Wholesale Modal
  if (wholesaleLink && wholesaleModal) {
  wholesaleLink.onclick = function() {
      wholesaleModal.style.display = "flex";
  };
  }

  // Event listener for swatches
  Array.prototype.forEach.call(swatches, function(swatch, index) {
  swatch.onclick = function() {
      openSwatchModal(index);
  };
  });

  // Event listener for affiliate items
  Array.prototype.forEach.call(affiliateItems, function(affiliate, index) {
  affiliate.onclick = function() {
      openAffiliateModal(index);
  };
  });

  // Close modals
  Array.prototype.forEach.call(closeBtns, function(closeBtn) {
  closeBtn.addEventListener("click", function() {
      if (swatchModal) swatchModal.style.display = "none";
      if (affiliateModal) affiliateModal.style.display = "none";
      if (wholesaleModal) wholesaleModal.style.display = "none"; // Close Wholesale Modal
  });
  });

  // Close modals on outside click
  window.addEventListener("click", function(event) {
  if (swatchModal && event.target == swatchModal) {
      swatchModal.style.display = "none";
  }
  if (affiliateModal && event.target == affiliateModal) {
      affiliateModal.style.display = "none";
  }
  if (wholesaleModal && event.target == wholesaleModal) {
      wholesaleModal.style.display = "none";
  }
  });

  // Navigate through swatch images
  Array.prototype.forEach.call(prevBtns, function(prevBtn) {
  prevBtn.onclick = function() {
      if (swatchModal && swatchModal.style.display === "flex") {
      currentIndex = (currentIndex - 1 + swatches.length) % swatches.length;
      swatchModalImg.src = swatches[currentIndex].src;
      swatchModalColourTitle.textContent = formatSwatchColourTitle(swatches[currentIndex].getAttribute("data-colour"));
      }
      if (affiliateModal && affiliateModal.style.display === "flex") {
      currentIndex = (currentIndex - 1 + affiliateItems.length) % affiliateItems.length;
      affiliateModalImg.src = affiliateItems[currentIndex].getAttribute("data-modal-src");
      }
  };
  });

  Array.prototype.forEach.call(nextBtns, function(nextBtn) {
  nextBtn.onclick = function() {
      if (swatchModal && swatchModal.style.display === "flex") {
      currentIndex = (currentIndex + 1) % swatches.length;
      swatchModalImg.src = swatches[currentIndex].src;
      swatchModalColourTitle.textContent = formatSwatchColourTitle(swatches[currentIndex].getAttribute("data-colour"));
      }
      if (affiliateModal && affiliateModal.style.display === "flex") {
      currentIndex = (currentIndex + 1) % affiliateItems.length;
      affiliateModalImg.src = affiliateItems[currentIndex].getAttribute("data-modal-src");
      }
  };
  });

  // Function to update navigation buttons state (if needed)
  function updateNavButtons() {
  // Implement logic for enabling/disabling navigation buttons if needed
  }

  // Ensure modals are hidden on page load
  function hideModals() {
  if (swatchModal) swatchModal.style.display = "none";
  if (affiliateModal) affiliateModal.style.display = "none";
  if (wholesaleModal) wholesaleModal.style.display = "none";
  }

  // Call hideModals to ensure they are hidden on initial load
  hideModals();
});